import React from "react";
import { Link } from "gatsby";

import { ContainerInner, ContainerOuter } from "@/components/Container";

function NavLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link to={to} className="transition hover:text-teal-500">
      {children}
    </Link>
  );
}

export function Footer() {
  return (
    <footer className="Footer mt-32 flex-none">
      <ContainerOuter>
        <div className="border-t border-zinc-100 pb-16 pt-10">
          <ContainerInner>
            <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
              <div className="flex flex-wrap justify-center gap-x-6 gap-y-1 text-sm font-medium text-zinc-800">
                <NavLink to="/about">About</NavLink>
                <NavLink to="/articles">Articles</NavLink>
                <NavLink to="/favorites">Favorites</NavLink>
              </div>
              <p className="text-sm text-zinc-400">
                &copy; {new Date().getFullYear()} Cliff Pyles. All rights reserved.
              </p>
            </div>
          </ContainerInner>
        </div>
      </ContainerOuter>
    </footer>
  );
}
